export const WS_TIME_DELAY = {
	seconds: 35,
} as const;

export const SENDER_STRINGS = {
	INPUT_PLACEHOLDER: 'Digite uma mensagem',
	SEND_ICON_ALT: 'ícone de enviar mensagem',
} as const;

function countConsecutiveDigits(text: string): number {
	let max = 0;
	let current = 0;
	for (const char of text) {
		if (char >= '0' && char <= '9') {
			current++;
			if (current > max) max = current;
		} else {
			current = 0;
		}
	}
	return max;
}

function hasPhoneNumber(text: string): boolean {
	return countConsecutiveDigits(text.replaceAll(/[\s.-]/g, '')) >= 8;
}

function hasEmail(text: string): boolean {
	return text.split(/\s+/).some((word) => {
		const atIndex = word.indexOf('@');
		if (atIndex < 1 || atIndex === word.length - 1) return false;
		const domain = word.slice(atIndex + 1);
		const dotIndex = domain.lastIndexOf('.');
		return dotIndex > 0 && domain.length - dotIndex - 1 >= 2;
	});
}

export function containsSensitiveData(text: string): boolean {
	return hasPhoneNumber(text) || hasEmail(text);
}

export function removeSensitiveData(text: string): string {
	const words = text.split(/(\s+)/);
	const filtered = words.map((word) => {
		if (hasEmail(word)) return '';
		if (hasPhoneNumber(word)) return '';
		return word;
	});
	return filtered.join('');
}
